import { render, staticRenderFns } from "./FileExportDropdown.vue?vue&type=template&id=8e0aa9e6"
import script from "./FileExportDropdown.vue?vue&type=script&lang=ts"
export * from "./FileExportDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports